import { render, staticRenderFns } from "./Tencent.vue?vue&type=template&id=cb944b34&scoped=true"
import script from "./Tencent.vue?vue&type=script&lang=js"
export * from "./Tencent.vue?vue&type=script&lang=js"
import style0 from "./Tencent.vue?vue&type=style&index=0&id=cb944b34&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb944b34",
  null
  
)

export default component.exports